<template>
    <div>
        <HeaderBar/>
        <div class="auth-wrapper auth-v2 ">
            <b-row class="auth-inner m-0">
                <div class="w-100 d-flex flex-column ">
                    <HeaderBar/>
                    <div class="mt-4  ">
                        <!-- Basic Module -->
                        <div class="d-flex justify-content-center align-items-center mb-1 mt-3 ml-2 mr-2 text-center">
                            <div class="title">Cargar Datos Reproductivos Hembras</div>
                            
                        </div>
                        
                        <div class="ml-1 mr-1 d-flex flex-column femaleButton ">
                        <b-link :to="{name:'basic-femaleIndex'}" style="color:white"> <b-button class="bg-primary w-100"  >Parto / Aborto</b-button></b-link>
                            <!-- :to="{name:'basic-femaledataloaddelivery'}" <b-link :to="{name:'basic-femaledataloadabort'}" style="color:white"><b-button class="bg-primary mt-1 w-100" >Aborto</b-button></b-link> -->
                            <b-link :to="{name:'basic-palpationIndex'}" style="color:white"><b-button class="bg-primary mt-1 w-100" >Palpaciones</b-button></b-link>
                            <b-link :to="{name:'basic-servicesIndex'}" style="color:white"><b-button class="bg-primary mt-1 w-100" >Servicios</b-button></b-link>
                        </div>
                    </div>
                </div>
            </b-row>
            <ControlMenu />
        </div>
    </div>
</template>


<script>
import { BButton, BLink, BRow, BImg } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
export default {
    components:{
        BRow,
        BImg,
        BButton,
        ControlMenu,
        HeaderBar,
        BLink,
    }
}
</script>

<style lang="scss">
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
}

.femaleButton {
    position: absolute;
    top:35%;
    color:white;
    width:93%;
  
}

</style>